$(function () {

    // Переход между шагами




    $(document).on('click', '.calculation__block .edit', function (e) {
        e.preventDefault();
        var allBlock = $('.calculation__block_step1, .calculation__block_step2, .calculation__block_step3');
        var allBlock4 = $('.calculation__block_step4');
        var parBlock = $(this).parents('.calculation__block');
        allBlock.find('.calculation__block-body').slideUp();
        $('.calculation__block_step4').fadeOut();
        parBlock.find('.calculation__block-body').slideDown();
        // parBlock.removeClass('editable');

    });

    // Сабмит страницы
    $(document).on('click', '.calculation__packet-line .calculation__packet', function (e) {
        // console.log('submit/redirect');
        var $this = $('.calculation__form');

        // calcPacket.openModal();


        setTimeout(function () {
            $this[0].submit();
        }, 100)

        // $.ajax({
        //     url: $this.attr('action'),
        //     type: $this.attr('method'),
        //     data: $this.serialize(),
        //     success: function () {
        //         $this[0].reset();
        //     }
        // });

    });

    if (getCookie("back_option_link") && getCookie("back_option_link") != undefined && $('main').hasClass('calculation')) {
        $('.calculation__top').attr('href', getCookie("back_option_link"))
        // console.log('calculation ', getCookie("back_option_link"));
        setTimeout(function () {
            deleteCookie("back_option_link");
        }, 100)

    }

})

var redirectDate = '';

// Предзаполнение полей калькулятора
if ($('main').hasClass('calculation step3')) {
    $(window).on('load', function () {
        if (getCookie("redirectino")) {
            console.log($('.calculation__block_step1').find('.simple-select__item[data-value=' + getCookie("guest_count1") + ']'));
            $('.calculation__block_step1').find('.simple-select__item[data-value=' + getCookie("guest_count1") + ']').click();

            // var preredirectDate = getCookie("date_val1").split('-');
            // redirectDate = preredirectDate[2] + ',' + preredirectDate[1] + ',' + preredirectDate[0];
            // console.log(redirectDate);
            // console.log(new Date(preredirectDate));
        }
    });

}
